import { trackEvent } from '@/lib/analytics'

export const SHOW_WHATS_NEW_MODAL_EVENT = 'codedesign:show-whats-new-modal'

export function openWhatsNewModal({ source = 'manual' } = {}) {
  if (typeof window === 'undefined') return

  trackEvent('WhatsNew:TriggerClicked', { source })
  window.dispatchEvent(
    new CustomEvent(SHOW_WHATS_NEW_MODAL_EVENT, { detail: { source } })
  )
}
